import { ref, uploadBytes } from 'firebase/storage';
import React, { useContext } from 'react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import UiSaveButtons from '../buttons/UiSaveButtons';
import TreeViewer from './TreeViewer';
import { fbAppConfigs } from 'project/appConfigs';

const AppManifest = () => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, manifest_state } = states
  const { manifestInfo } = manifest_state ?? {}
  const { mainStorage } = app_state ?? {}

  const updateStorageManifest = async () => {
    const { settingsDocName, manifest } = manifestInfo ?? {}
    const _manifest = JSON.stringify(manifest, null, 2)
    const manifestRef = ref(mainStorage, 'allManifests/' + settingsDocName);
    const blob = new Blob([_manifest], { type: 'application/json' });

    const cb = (res) => {
      console.log('res', res)
    }

    const bucketFolder = 'allManifests'
    const projectIds = {
      source: appKeys.dev
    }

    try {
      await uploadBytes(manifestRef, blob);
      fn_cls.makeAllManifestsPublic(projectIds, bucketFolder, cb)
      console.log(`✅ Manifest uploaded as ${settingsDocName}.json`);
    } catch (err) {
      console.error("❌ Error uploading manifest:", err);
    }
  }

  const handleUpdateManifest = () => updateStorageManifest()

  const wrapper = () => <Wrapper
    content={manifestInfo ? <TreeViewer data={manifestInfo} /> : <div>No Manifest Info</div>}
    footer={<UiSaveButtons save={{ oc: handleUpdateManifest, disabled: !manifestInfo, caption: 'Update Manifest' }} />}
    wrapperType={wrapperTypes.padded}
    css={{ content: 'quick-view' }}
  />

  return wrapper()

}

export default AppManifest